import * as React from "react";
import ButtonSecondary from "widget/buttonSecondary";
import { connect } from "react-redux";

interface ISignsProps {
  // 订单号
  orderNo: any;
  // 批量发货
  batchSign: any;
  // 刷新订单
  searchOrder: any;
}

// 批量签名
class Signs extends React.Component<ISignsProps, any> {
  constructor(props: ISignsProps) {
    super(props);
  }

  renderText = () => {
    return (
      <div>
        <span>确定为选中的</span>
        <span style={{ color: "red" }}>{this.props.orderNo.length}</span>
        <span>个订单签名吗？</span>
      </div>
    );
  };

  render() {
    return (
      <div className="button-group-child">
        <ButtonSecondary
          buttonText="批量签名"
          modalTitle="批量签名"
          ids={this.props.orderNo}
          modalText={this.renderText()}
          warningText="请选择订单"
          successText="批量签名成功"
          submit={this.props.batchSign}
          cb={this.props.searchOrder}
        />
      </div>
    );
  }
}

const mapDispatch = dispatch => {
  return {
    batchSign: dispatch.orderInfo.batchSign
  };
};

export default connect(
  null,
  mapDispatch
)(Signs);
